import * as React from "react";
import { useEffect } from "react";
import { Route, Routes, HashRouter as Router } from "react-router-dom";
import Box from "@mui/material/Box";
import { UIConfiguration } from "./components/common/models/ui-configuration-Models";
import UIConfigurationHelper from "./components/common/services/ui-configurationHelper";
import { UIConfigurationProvider } from "./components/common/contexts/ui-configurationContext";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { CommonConstants } from "./components/common/constants/common-constants";
import { publicRoutes, schoolRoutes, facilitatorRoutes, sharedRoutes } from "./routes/routeConfig";
import { ProtectedRoute, DualProtectedRoute } from "./components/common/ProtectedRoute";

const defaultConfig: UIConfiguration = {
  pageTitle: '',
  logoConfiguration: {
    logoURL: '',
    logoStyle: {},
    altText: ''
  },
  loginPageImage: '',
  contactNumbers: [],
  downloads: []
};

export default function App() {
  const configData = UIConfigurationHelper.get();
  const uiConfigData: UIConfiguration = configData || defaultConfig;
  useEffect(() => {
    if (uiConfigData?.pageTitle) {
      document.title = uiConfigData.pageTitle;
    }
  }, [uiConfigData.pageTitle]);

  return (
    <UIConfigurationProvider config={uiConfigData}>
      <Box sx={{ display: "flex", backgroundColor: '#f5f5f5', height: '100vh' }}>
        <Router>
          <Routes>
            {publicRoutes.map(({ path, element: Element }) => (
              <Route key={path} path={path} element={<Element />} />
            ))}
            
            {schoolRoutes.map(({ path, element: Element }) => (
              <Route
                key={path}
                path={path}
                element={
                  <ProtectedRoute userType={CommonConstants.UserType.School}>
                    <Element />
                  </ProtectedRoute>
                }
              />
            ))}

            {facilitatorRoutes.map(({ path, element: Element }) => (
              <Route
                key={path}
                path={path}
                element={
                  <ProtectedRoute userType={CommonConstants.UserType.Admin}>
                    <Element />
                  </ProtectedRoute>
                }
              />
            ))}

            {sharedRoutes.map(({ path, schoolElement, facilitatorElement }) => (
              <Route
                key={path}
                path={path}
                element={
                  <DualProtectedRoute
                    schoolComponent={schoolElement}
                    facilitatorComponent={facilitatorElement}
                  />
                }
              />
            ))}
          </Routes>
        </Router>
      </Box>
      <ToastContainer />
    </UIConfigurationProvider>
  );
};
